import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Backend"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postBackendByService: build.mutation<
        PostBackendByServiceApiResponse,
        PostBackendByServiceApiArg
      >({
        query: (queryArg) => ({
          url: `/backend/${queryArg.service}`,
          method: "POST",
          body: queryArg.dataFieldsMeasuringPointsDto,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            dataCollectorRequestType: queryArg.dataCollectorRequestType,
          },
        }),
        invalidatesTags: ["Backend"],
      }),
      postDataCollectorGetRun: build.mutation<
        PostDataCollectorGetRunApiResponse,
        PostDataCollectorGetRunApiArg
      >({
        query: (queryArg) => ({
          url: `/DataCollector/GetRun`,
          method: "POST",
          body: queryArg.body,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            maxRuns: queryArg.maxRuns,
          },
        }),
        invalidatesTags: ["Backend"],
      }),
      getDataCollectorRun: build.mutation<
        GetDataCollectorRunApiResponse,
        GetDataCollectorRunApiArg
      >({
        query: (queryArg) => ({
          url: `/DataCollector/Run`,
          method: "GET",
          params: {
            start: queryArg.start,
            end: queryArg.end,
            maxRuns: queryArg.maxRuns,
          },
        }),
        invalidatesTags: ["Backend"],
      }),
      getDataCollectorRunLastXMinutes: build.mutation<
        GetDataCollectorRunLastXMinutesApiResponse,
        GetDataCollectorRunLastXMinutesApiArg
      >({
        query: (queryArg) => ({
          url: `/DataCollector/RunLastXMinutes`,
          method: "GET",
          params: {
            minutesToCollect: queryArg.minutesToCollect,
            maxRuns: queryArg.maxRuns,
          },
        }),
        invalidatesTags: ["Backend"],
      }),
      postIrregularDataCheckerGetRun: build.mutation<
        PostIrregularDataCheckerGetRunApiResponse,
        PostIrregularDataCheckerGetRunApiArg
      >({
        query: (queryArg) => ({
          url: `/IrregularDataChecker/GetRun`,
          method: "POST",
          body: queryArg.body,
          params: { start: queryArg.start, end: queryArg.end },
        }),
        invalidatesTags: ["Backend"],
      }),
      getIrregularDataCheckerRun: build.mutation<
        GetIrregularDataCheckerRunApiResponse,
        GetIrregularDataCheckerRunApiArg
      >({
        query: (queryArg) => ({
          url: `/IrregularDataChecker/Run`,
          method: "GET",
          params: { start: queryArg.start, end: queryArg.end },
        }),
        invalidatesTags: ["Backend"],
      }),
      getIrregularDataCheckerRunLastXMinutes: build.mutation<
        GetIrregularDataCheckerRunLastXMinutesApiResponse,
        GetIrregularDataCheckerRunLastXMinutesApiArg
      >({
        query: (queryArg) => ({
          url: `/IrregularDataChecker/RunLastXMinutes`,
          method: "GET",
          params: { minutesToCollect: queryArg },
        }),
        invalidatesTags: ["Backend"],
      }),
      postQuantileCalculatorGetRun: build.mutation<
        PostQuantileCalculatorGetRunApiResponse,
        PostQuantileCalculatorGetRunApiArg
      >({
        query: (queryArg) => ({
          url: `/QuantileCalculator/GetRun`,
          method: "POST",
          body: queryArg.body,
          params: { start: queryArg.start, end: queryArg.end },
        }),
        invalidatesTags: ["Backend"],
      }),
      getQuantileCalculatorRun: build.mutation<
        GetQuantileCalculatorRunApiResponse,
        GetQuantileCalculatorRunApiArg
      >({
        query: (queryArg) => ({
          url: `/QuantileCalculator/Run`,
          method: "GET",
          params: { start: queryArg.start, end: queryArg.end },
        }),
        invalidatesTags: ["Backend"],
      }),
      getQuantileCalculatorRunLastXWeeks: build.mutation<
        GetQuantileCalculatorRunLastXWeeksApiResponse,
        GetQuantileCalculatorRunLastXWeeksApiArg
      >({
        query: (queryArg) => ({
          url: `/QuantileCalculator/RunLastXWeeks`,
          method: "GET",
          params: { weeks: queryArg },
        }),
        invalidatesTags: ["Backend"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as backendApi };
export type PostBackendByServiceApiResponse = /** status 200 OK */ void;
export type PostBackendByServiceApiArg = {
  service: string;
  start: string;
  end: string;
  dataCollectorRequestType?: DataCollectorRequestType;
  dataFieldsMeasuringPointsDto: DataFieldsMeasuringPointsDto;
};
export type PostDataCollectorGetRunApiResponse = /** status 200 OK */ void;
export type PostDataCollectorGetRunApiArg = {
  start: string;
  end: string;
  maxRuns: number;
  body: string[];
};
export type GetDataCollectorRunApiResponse = /** status 200 OK */ void;
export type GetDataCollectorRunApiArg = {
  start: string;
  end: string;
  maxRuns: number;
};
export type GetDataCollectorRunLastXMinutesApiResponse =
  /** status 200 OK */ void;
export type GetDataCollectorRunLastXMinutesApiArg = {
  minutesToCollect: number;
  maxRuns: number;
};
export type PostIrregularDataCheckerGetRunApiResponse =
  /** status 200 OK */ void;
export type PostIrregularDataCheckerGetRunApiArg = {
  start: string;
  end: string;
  body: string[];
};
export type GetIrregularDataCheckerRunApiResponse = /** status 200 OK */ void;
export type GetIrregularDataCheckerRunApiArg = {
  start: string;
  end: string;
};
export type GetIrregularDataCheckerRunLastXMinutesApiResponse =
  /** status 200 OK */ void;
export type GetIrregularDataCheckerRunLastXMinutesApiArg = number;
export type PostQuantileCalculatorGetRunApiResponse = /** status 200 OK */ void;
export type PostQuantileCalculatorGetRunApiArg = {
  start: string;
  end: string;
  body: string[];
};
export type GetQuantileCalculatorRunApiResponse = /** status 200 OK */ void;
export type GetQuantileCalculatorRunApiArg = {
  start: string;
  end: string;
};
export type GetQuantileCalculatorRunLastXWeeksApiResponse =
  /** status 200 OK */ void;
export type GetQuantileCalculatorRunLastXWeeksApiArg = number;
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type DataCollectorRequestType = "all" | "measurements" | "events";
export type DataFieldsMeasuringPointsDto = {
  dataFields?: string[] | null;
  measuringPoints?: string[] | null;
};
export const {
  usePostBackendByServiceMutation,
  usePostDataCollectorGetRunMutation,
  useGetDataCollectorRunMutation,
  useGetDataCollectorRunLastXMinutesMutation,
  usePostIrregularDataCheckerGetRunMutation,
  useGetIrregularDataCheckerRunMutation,
  useGetIrregularDataCheckerRunLastXMinutesMutation,
  usePostQuantileCalculatorGetRunMutation,
  useGetQuantileCalculatorRunMutation,
  useGetQuantileCalculatorRunLastXWeeksMutation,
} = injectedRtkApi;
